export const SAVED_STAFF_AUTHENTICATION_CREDENTIALS_LOCAL_STORAGE_KEY = 'SAVED_STAFF_AUTHENTICATION_CREDENTIALS_LOCAL_STORAGE_KEY';

export default {
  saveStaffAuthenticationCredentialsByStaffTokenAndId(staffToken: any, pinCode: string) {
    let savedStaffsAuthenticationCredentials: any = this.getSavedStaffAuthenticationCredentials();

    if (savedStaffsAuthenticationCredentials !== null) {
      savedStaffsAuthenticationCredentials = JSON.parse(savedStaffsAuthenticationCredentials);
    } else {
      savedStaffsAuthenticationCredentials = {};
    }

    savedStaffsAuthenticationCredentials[pinCode] = staffToken;

    localStorage.setItem(
      SAVED_STAFF_AUTHENTICATION_CREDENTIALS_LOCAL_STORAGE_KEY,
      JSON.stringify(savedStaffsAuthenticationCredentials)
    );
  },
  removeStaffAuthenticationCredentialsByStaffId(pinCode: string) {
    let savedStaffsAuthenticationCredentials: any = this.getSavedStaffAuthenticationCredentials();

    if (savedStaffsAuthenticationCredentials !== null) {
      savedStaffsAuthenticationCredentials = JSON.parse(savedStaffsAuthenticationCredentials);

      delete savedStaffsAuthenticationCredentials[pinCode];

      localStorage.setItem(
        SAVED_STAFF_AUTHENTICATION_CREDENTIALS_LOCAL_STORAGE_KEY,
        JSON.stringify(savedStaffsAuthenticationCredentials)
      );
    }
  },
  isHaveSignedStaffs(): boolean {
    let savedStaffsAuthenticationCredentials: any = this.getSavedStaffAuthenticationCredentials();

    if (savedStaffsAuthenticationCredentials !== null) {
      savedStaffsAuthenticationCredentials = JSON.parse(savedStaffsAuthenticationCredentials);

      return Object.values(savedStaffsAuthenticationCredentials).length > 0;
    }

    return false;
  },
  getSavedStaffAuthenticationCredentials(): string | null {
    return localStorage.getItem(SAVED_STAFF_AUTHENTICATION_CREDENTIALS_LOCAL_STORAGE_KEY);
  }
};
